






































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class AlertDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop() content: string;
  @Prop() title: string;
}
